import type { Reward } from '../../shared/types';

/**
 * Rewards are edited as one line ("50 Glimmer, 5 Growth Flower") rather than a
 * row of inputs, because codes get added in a hurry from a phone.
 */
export function parseRewards(text: string): Reward[] {
  return text
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => {
      const match = /^([\d,]+)\s*x?\s+(.*)$/i.exec(part);
      if (!match) return { amount: null, item: part };

      const amount = Number(match[1].replace(/,/g, ''));
      return Number.isFinite(amount)
        ? { amount, item: match[2].trim() }
        : { amount: null, item: part };
    });
}

export function serializeRewards(rewards: Reward[]): string {
  return rewards
    .map((reward) => (reward.amount === null ? reward.item : `${reward.amount} ${reward.item}`))
    .join(', ');
}
